module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/hyper_2x.f831c68.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/hyper_2x.png
// module id = IqVO
// module chunks = 41